import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './company_edit.route';

import CompanyService from '../../../components/api/company/company.service';
import EndUserService from '../../../components/api/end_user/end_user.service';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';

export class CompanyEditController {
    /*@ngInject*/
    constructor($stateParams, $state, $mdDialog, CompanyService, EndUserService, SaConfigService) {
        this.id = $stateParams.company_id;
        this.CompanyService = CompanyService;
        this.EndUserService = EndUserService
        this.SaConfigService = SaConfigService;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.company_dialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose: true,
                title: '顧客名を変更しますか？',
                ok: '変更する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '変更しました',
                ok: 'OK'
            })
        };

        this.companyDestroyDialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose: true,
                title: '顧客を削除しますか？',
                ok: '削除する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '顧客を削除しました',
                ok: 'OK'
            }),
            error: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '顧客配下に機器が存在しています',
                content: '顧客を削除するには配下の機器を全て解約してください。',
                ok: 'OK'
            })
        };

        this.user_dialog = {
            confirm: $mdDialog.confirm({
                clickOutsideToClose: true,
                title: 'パスワードを更新しますか？',
                content: '以前のパスワードではログインできなくなります',
                ok: '更新する',
                cancel: '戻る'
            }),
            success: $mdDialog.alert({
                clickOutsideToClose: true,
                title: '更新しました',
                ok: 'OK'
            })
        }

        this.error_dialog = $mdDialog.alert({
            clickOutsideToClose: true,
            title: 'エラーが発生しました',
            content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
            ok: 'OK'
        });
    }

    $onInit() {
        this.CompanyService.show({ id: this.id }, response => {
            this.company = response;
        }, err => {
            if(err.status === 404 || err.status === 403) { this.$state.go('oem_main.oem_home'); }
        });

        this.EndUserService.oem_api.index({ company_id: this.id }, response => {
            this.supportAccount = response[0];
        });

        this.SaConfigService.oem_api.index({ company_id: this.id }, response => {
            this.saConfigList = response;
        });
     }

     updateCompany() {
         this.$mdDialog.show(this.company_dialog.confirm)
            .then(() => {
                this.CompanyService.update(
                    this.company,
                    okResponse => { this.$mdDialog.show(this.company_dialog.success); },
                    errResponse => { this.$mdDialog.show(this.error_dialog); }
                );
            });
     }

     updateUser() {
         this.$mdDialog.show(this.user_dialog.confirm)
            .then(() => {
                this.EndUserService.oem_api.update(
                    { id: this.supportAccount.id },
                    okResponse => {
                        this.supportAccount = okResponse;
                        this.$mdDialog.show(this.user_dialog.success);
                    },
                    errResponse => { this.$mdDialog.show(this.error_dialog); }
                );
            });
     }

     destroyCompany() {
         if(this.saConfigList.length > 0) {
             this.$mdDialog.show(this.companyDestroyDialog.error);
             return;
         }

         this.$mdDialog.show(this.companyDestroyDialog.confirm)
         .then(() => {
            this.CompanyService.destroy(
                { id: this.id },
                ok => {
                    this.$mdDialog.show(this.companyDestroyDialog.success).finally(() => {
                        this.$state.go('oem_main.company_index');
                    });
                },
                ng => {
                    this.$mdDialog.show(this.error_dialog);
                }
            )
         });
     }


     copyToClip(event) {
         const prev = event.target.previousElementSibling;
         prev.select();
         document.execCommand("Copy");
     }
}

export default angular.module('leptonApp.companyEdit', [uiRouter, CompanyService, EndUserService, SaConfigService])
    .config(routing)
    .component('companyEdit', {
        template: require('./company_edit.html'),
        controller: CompanyEditController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/company/edit/company_edit.component.js